import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-11 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m.25-3a.75.75 0 0 0 1.5 0V7a.75.75 0 0 0-1.5 0z"
      clipRule="evenodd"
    />
  </svg>
);
export const IconWarningSolid = withDynamicStroke(Icon);
